module.exports = __webpack_public_path__ + "img/displayIndex.40bc380c.jpg";